import { render, staticRenderFns } from "./HorarioTabs.vue?vue&type=template&id=4a5accce&scoped=true"
import script from "./HorarioTabs.vue?vue&type=script&lang=js"
export * from "./HorarioTabs.vue?vue&type=script&lang=js"
import style0 from "./HorarioTabs.vue?vue&type=style&index=0&id=4a5accce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5accce",
  null
  
)

export default component.exports